export const canDownload = typeof document !== 'undefined';

export const downloadTextFile = async (
    filename: string,
    content: string,
    mimeType: string = 'text/csv;charset=utf-8'
): Promise<void> => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 0);
};
